// extracted by mini-css-extract-plugin
export default {"appbar":"appBar_appbar__8cZHU","appbar-shadow":"appBar_appbar-shadow__NpQUY"};